import Vue from 'vue';
import MehrwertssteuerService from './mehrwertssteuer.service';
import * as _ from 'lodash';
import abstractStore from '../../store/abstractstore';

export const getDefaultSort = () => ({ currentSort: 'mwst', currentSortDir: 'asc' });

const getDefaultItem = () => ({
    id: null,
    mwst: null,
    defaultMwst: false,
    land: {},
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    all: [],
    ...abstractStore.getAbstractValue(getDefaultSort().currentSort, getDefaultSort().currentSortDir),
});

const mehrwertssteuer = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        updateAll(state, data) {
            Vue.set(state, 'all', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
            Vue.set(state, 'all', getDefaultState().all);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await MehrwertssteuerService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await MehrwertssteuerService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await MehrwertssteuerService.get(id);
            context.commit('update', data);
            return data;
        },
        async getAll(context) {
            const { data } = await MehrwertssteuerService.getAll();
            context.commit('updateAll', data);
            return data;
        },
        async query(context, params) {
            const { headers, data } = await MehrwertssteuerService.query(params);

            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));

            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await MehrwertssteuerService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
        all(state) {
            return state.all;
        }
    },
};

export default _.merge(mehrwertssteuer, abstractStore.getDefaultStore());
